import React, { useState } from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';

import { Button } from '@lwt-helix/buttons';

import RemoveUserModal from './RemoveUserModal';

const RemoveUser = ({
    clientId,
    error,
    response,
    permissions,
    userId,
    onRemove
}) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const toggleModalStatus = () => {
        setModalIsOpen(!modalIsOpen)
    };
    const isManageUsers = 'U-U' in permissions;
    const usersModal = modalIsOpen
        ? (
            <RemoveUserModal
                show={modalIsOpen}
                closeModal={toggleModalStatus}
                onRemove={onRemove}
                userId={userId}
                clientId={clientId}
                error={error}
                response={response}
            />
        )
        : null;

    return (
        <>
            <Button
                className="mr-auto"
                color="danger"
                onClick={toggleModalStatus}
                dataLwtId="remove-user-button"
                disabled={!isManageUsers}
            >
                REMOVE USER
            </Button>
            {usersModal}
        </>
    );
};

function mapStateToProps(state) {
    return {
        clientId: state.authenticationReducer.user.orgId,
        error: state.authenticationReducer.removeUserError,
        response: state.authenticationReducer.removeUserResponse,
        permissions: state.authorizationReducer.permissions.permissions
    };
}

RemoveUser.propTypes = {
    clientId: PropTypes.string,
    error: PropTypes.object,
    response: PropTypes.object,
    permissions: PropTypes.array,
    userId: PropTypes.string,
    onRemove: PropTypes.func
};

export default connect(mapStateToProps)(RemoveUser);